import AsyncStorage from "@react-native-async-storage/async-storage";
import type { IStorageProvider } from "unleash-proxy-client";

type UseUnleashStorageProvider = () => IStorageProvider | undefined;

/**
 * Prefix for all keys going into storage, taken from Unleash's default when using web localStorage.
 * Unleash by default uses two main keys:
 * - `sessionId` for stickiness of flags
 * - `repo` containing an array of objects representing the flag values
 */
const PREFIX = "unleash:repository:";
const getKey = (name: string) => `${PREFIX}${name}`;

export const useUnleashStorageProvider: UseUnleashStorageProvider = () => ({
  get: async name => {
    const key = getKey(name);
    const data = await AsyncStorage.getItem(key);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return data === null ? undefined : JSON.parse(data);
  },
  save: async (name, data) => {
    const key = getKey(name);
    await AsyncStorage.setItem(key, JSON.stringify(data));
  },
});
